import { doc, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase";

export function subscribeAnalytics(eventId, onData, onError) {
  return onSnapshot(
    doc(db, "analytics", eventId),
    (snap) => onData(snap.exists() ? snap.data() : null),
    onError
  );
}

export async function recomputeAnalytics(eventId) {
  const fn = httpsCallable(functions, "computeEventAnalytics");
  const res = await fn({ eventId });
  return res.data; // { ok, remaining, unlimited }
}
